export const defaultSelectedTipoListaChequeo = () => {
    return {
        tipo_lista: '',
        tipo_seguimiento: [],
        items: []
    };
};

export const filtro = () => {
    return {
        buscar: '',
        paginado: true,
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
    };
};

export default {
    selectedTipoListaChequeo: defaultSelectedTipoListaChequeo(),
    tipoListaChequeo: [],
    tipoSeguimiento: [],
    tiposSeguimientoSeleccionados: [],
    temporalSeguimientoSeleccionados: [],
    itemsSeleccionados: [],
    accion: 'Crear',
    error: false,
    filtro: filtro(),
    empresas: [],
    empresas_filtradas: [],
    modal_empresas: {
        ver: false
    },
    // Control de los collapse (contenido) para la Vista previa
    collapseViewer: {
        id: null,
        name: null,
        status: false
    }
};
